import { priceFormatter } from '../OrganizationBilling';

/**
 * Display a number as a dollar amount.
 */
export function PrettyDollarNumber(props: { value: number; className?: string }) {
    const { value, className } = props;

    return <span className={className}>{priceFormatter.format(value)}</span>;
}
